import { format, toZonedTime } from 'date-fns-tz';
import processData from './dataProcessor';

async function getAssetData(imageFileName: string, accessToken: string, clientAPIURL: string) {
  try {
    const finalUri = clientAPIURL + "api/getAsset/" + imageFileName;
    const response = await fetch(finalUri, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'cache': 'force-cache'
      },
    });
    return response;
  }
  catch (error) {
    console.error(error);
  }
}

async function triggerWorkflow(path: string, itemID: number, status: string, packageName: string, siteId: string, listTitle: string, api: string, accessToken: string) {
  const data = {
    "listPath": path,//"greenport/dgda/ss01/TrainingObservations/EnvironmentalIssuesObservations",
    "itemID": itemID,
    "status": status,
    "packageName": packageName,
    "siteId": siteId,
    "listTitle": listTitle
  }
  try {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data)
    };
    const result = await fetch(api + "api/triggerWorkflow", requestOptions);
    return result;
  } catch (error) {
    console.error(error);
  }

}

async function triggerReportRequest(
  logTitle: string,
  accessToken: string,
  clientAPIURL: string,
  data: any
) {
  // const data = {
  //   template: template,
  //   period: period,
  //   logTitle: logTitle
  // };

  try {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(data),
    };
    const response = await fetch(`${clientAPIURL}api/triggerReportRequest`, requestOptions);

    if (!response.ok) {
      // Handle HTTP errors
      console.error(`Error: ${response.status} ${response.statusText}`);
    }

    const result = response
    return result; // Return the parsed JSON response
  } catch (error) {
    console.error('Error in triggerReportRequest:', error);
    console.error(error) // Re-throw error for caller to handle if needed
  }
}
function findProjectParent(siteResp: any, siteId: string): any | null {
  function findParentById(site: any, id: string): any | null {
    if (!site.children) return null;

    for (const child of site.children) {
      if (child.id === id) return site; // Direct parent found
      const parent = findParentById(child, id);
      if (parent) return parent; // Recursively check parents
    }
    return null;
  }

  // Start from given site and move up until we reach project-level site
  let currentSite = siteResp;
  let parent = findParentById(siteResp, siteId);

  while (parent) {
    // If the parent is a project-level site (2 segments in path), return it
    if (parent.path.split("-").length === 2) {
      return parent;
    }
    // Move up the hierarchy
    currentSite = parent;
    parent = findParentById(siteResp, currentSite.id);
  }

  return null; // No project-level parent found
}
const getComplianceConfig = async (API_URL: string, accessToken: string, projectId: string) => {
  try {
    const url = `${API_URL}api/config/${projectId}_complianceConfig`; // Ensure the endpoint format is correct

    const requestOptions = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json(); // Correctly parse JSON
    return data.configValue || {};
    //return data.configValue ? JSON.parse(data.configValue) : {}; // Parse stored JSON
  } catch (error) {
    console.error("Error fetching compliance config:", error);
    return null;
  }
}

const getKpiConfig = async (clientAPIURL: string, accessToken: string) => {
  try {
    const url = `${clientAPIURL}api/config/kpiConfig`;
    const requestOptions = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.configValue || null;
  } catch (error) {
    console.error("Error fetching KPI config:", error);
    return null;
  }
}

const getAppSettingsConfig = async (clientAPIURL: string, accessToken: string) => {
  try {
    const url = `${clientAPIURL}api/config/appSettings`;
    const requestOptions = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.configValue || null;
  } catch (error) {
    console.error("Error fetching app settings config:", error);
    return null;
  }
}

function findSiteById(siteresp: any, siteId: string) {
  if (!siteresp.children || siteresp.children.length === 0) {
    return null; // No children, return null
  }

  for (let child of siteresp.children) {
    if (child.id === siteId) {
      return child; // Found the matching site
    }

    // Recursively search in child nodes
    const foundSite: any = findSiteById(child, siteId);
    if (foundSite) return foundSite;
  }

  return null; // Site not found in any children
}
function findImmediateParent(siteResp: any, siteId: string): any | null {
  // Recursive helper to search through children
  function searchParent(site: any, id: string): any | null {
    if (!site.children) return null;

    for (const child of site.children) {
      if (child.id === id) {
        return site; // Found direct parent
      }

      const parent = searchParent(child, id); // Recursively check deeper
      if (parent) {
        return parent; // Propagate found parent up
      }
    }

    return null;
  }

  return searchParent(siteResp, siteId);
}
async function getAllItems(logTitle: string, accessToken: string, clientAPIURL: string, siteId: string, projectId?: string, packageId: string = undefined) {

  //if(logTitle === "Noise Monitoring Log" || logTitle === "Vibration Monitoring Log" || logTitle === "PM2.5 Monitoring Log" || logTitle === "PM10 Monitoring Log")
  let ComplianceConfig = null;
  if (projectId) {
    ComplianceConfig = await getComplianceConfig(clientAPIURL, accessToken, projectId)
  }

  const finalUri = clientAPIURL + "api/sites/" + siteId + "/lists/" + logTitle + "/items"
  try {
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    const response = await fetch(finalUri, requestOptions);
    const d = await response.json();

    const packageStatusUri = packageId && clientAPIURL + "api/sites/" + packageId + "/lists/Package Status" + "/items"
    const packageStatusResponse = packageStatusUri && await fetch(packageStatusUri, requestOptions);
    const packageStatusResponseJson = packageStatusResponse && await packageStatusResponse.json();
    const processedItems = processData(logTitle, d.items, ComplianceConfig, packageStatusResponseJson?.items ? packageStatusResponseJson.items : undefined);
    return {
      //items: processedItems.sort((a: any, b: any) => new Date(b.Date) - new Date(a.Date)),
      //items: processedItems.sort((a: any, b: any) => b.ID - a.ID),
      items: processedItems,
      columns: d.columns
    };
  } catch (error) {
    console.error(error);
  }
}
// function processData(logTitle: string, data: any) {
//   switch (logTitle) {
//     case 'Noise Monitoring Log':
//       return (
//         processData_Noise(data)
//       )
//     case 'Energy Log':
//       return (
//         processData_Energy(data)
//       )
//       case 'Water Log':
//         return (
//           processData_Water(data)
//         )
//         case 'Imported Soil Log':
//         return (
//           processData_Soil(data)
//         )
//         case 'Hazardous Material Storage Log':
//         return (
//           processData_HazMaterial(data)
//         )
//         case 'Recycled Materials Log':
//         return (
//           processData_RecycledMaterials(data)
//         )
//         case 'Regional Materials Log':
//         return (
//           processData_RegionalMaterials(data)
//         )
//         case 'Vibration Monitoring Log':
//         return (
//           processData_Vibration(data)
//         )
//         case 'PM10 Monitoring Log':
//         return (
//           processData_PM10(data)
//         )
//         case 'PM2.5 Monitoring Log':
//         return (
//           processData_PM2P5(data)
//         )
//         case 'Wastewater Tracking Log':
//         return (
//           processData_WasteWater(data)
//         )
//         case 'Waste Tracking Log':
//         return (
//           processData_Waste(data)
//         )
//         case 'Spoil Tracking Log':
//         return (
//           processData_Spoil(data)
//         )
//         case 'Training Log':
//         return (
//           processData_Training(data)
//         )
//         case 'Environmental Issues Observations':
//         return (
//           processData_Observations(data)
//         )
//         case 'Permit Register':
//         return (
//           processData_PermitRegister(data)
//         )
//         case 'Monthly Waste Log':
//         return (
//           processData_Waste(data)
//         )
//         case 'Report Request':
//         return (
//           processData_ReportRequest(data)
//         )
//         case 'Project Records':
//         return (
//           processData_ProjectRecords(data)
//         )
//     default: return data
//   }
// }

async function getPackageStatus(accessToken: string, clientAPIURL: string, packageId: string) {
  try {
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    const packageStatusUri = packageId && clientAPIURL + "api/sites/" + packageId + "/lists/Package Status" + "/items"
    const response = await fetch(packageStatusUri, requestOptions);
    const d = await response.json();
    return d.items
  } catch (error) {
    console.error(error);
  }

}
function processData_Energy(data: any) {
  const updatedData = data.map((item: any) => {
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Period, key, Date };
  });
  return updatedData;
}
function processData_Water(data: any) {
  const updatedData = data.map((item: any) => {
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Period, key, Date };
  });
  return updatedData;
}
function processData_Soil(data: any) {
  const updatedData = data.map((item: any) => {
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Period, key, Date };
  });
  return updatedData;
}
function processData_HazMaterial(data: any) {
  const updatedData = data.map((item: any) => {
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Period, key, Date };
  });
  return updatedData;
}
function processData_RecycledMaterials(data: any) {
  const updatedData = data.map((item: any) => {
    const key = item.ID;
    const TotalValueOfRecycleContentMaterial = (item.MaterialValue * item.RecycledContentPostConsumer) + (item.MaterialValue * item.RecycledContentPreConsumer * 0.5);
    return { ...item, key, TotalValueOfRecycleContentMaterial };
  });
  return updatedData;
}
function processData_RegionalMaterials(data: any) {
  const updatedData = data.map((item: any) => {
    const key = item.ID;
    return { ...item, key };
  });
  return updatedData;
}
function processData_Vibration(data: any) {
  const updatedData = data.map((item: any) => {
    let conformity = "";
    if (item.MonitoringResultsMaxPPVmms != "") {
      conformity = item.MonitoringResultsMaxPPVmms <= item.ComplianceLimitmms ? "Conformity" : "Non Conformity";
    }

    const Conformity = conformity
    const pieKey = Conformity;
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Conformity, Period, key, Date, pieKey };
  });
  return updatedData;
}
function processData_PM10(data: any) {
  const updatedData = data.map((item: any) => {
    let conformity = "";
    if (item.MonitoringResultsugm3 != "") {
      //conformity = item.MonitoringResultsugm3 <= item.ComplianceStandardugm3 ? "Conformity" : "Non Conformity";
      conformity = item.MonitoringResultsugm3 <= 340 ? "Conformity" : "Non Conformity";
    }

    const Conformity = conformity
    const pieKey = Conformity;
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Conformity, Period, key, Date, pieKey };
  });
  return updatedData;
}
function processData_PM2P5(data: any) {
  const updatedData = data.map((item: any) => {
    let conformity = "";
    if (item.MonitoringResultsugm3 != "") {
      //conformity = item.MonitoringResultsugm3 <= item.ComplianceStandardugm3 ? "Conformity" : "Non Conformity";
      conformity = item.MonitoringResultsugm3 <= 35 ? "Conformity" : "Non Conformity";
    }
    const Conformity = conformity
    const pieKey = Conformity;
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Conformity, Period, key, Date, pieKey };
  });
  return updatedData;
}
function processData_WasteWater(data: any) {
  const updatedData = data.map((item: any) => {
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Period, key, Date };
  });
  return updatedData;
}
function processData_Waste(data: any) {
  const updatedData = data.map((item: any) => {
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    const Hazardous: string = checkHazardous(item.WasteType);
    const Diverted: string = checkDiverted(item.WasteDisposalMethod);

    return { ...item, Period, key, Date, Hazardous, Diverted };
  });
  return updatedData;
}
function processData_Spoil(data: any) {
  const updatedData = data.map((item: any) => {
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    const Reused: string = checkReused(item.SpoilDisposalMethod);
    return { ...item, Period, key, Date, Reused };
  });
  return updatedData;
}
function processData_Training(data: any) {
  const updatedData = data.map((item: any) => {
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Period, key, Date };
  });
  return updatedData;
}
function processData_Observations(data: any) {
  const updatedData = () => {
    return data.map((item: any) => ({
      ...item,
      Period: item.Date && GetPeriod(item.Date),
      key: item.ID,
      Date: item.Date && returnDate(item.Date),
      DueDate: item.DueDate ? returnDate(item.DueDate) : null,
      DateClosedOut: item.DateClosedOut ? returnDate(item.DateClosedOut) : null,
      //Status: checkStatus(item.ClosedOut),
      Status: item.Status && item.Status === "Escalated" ? "Escalated" : checkStatus(item.ClosedOut),
      ReferenceNumber: item.ReferenceNumber ? `${item.ReferenceNumber}-${item.ID}` : item.ID
    }));
  };
  return updatedData;
}
function processData_PermitRegister(data: any) {
  const updatedData = data.map((item: any) => {
    const key = item.ID;
    const PermitValidity = item.PermitValidity && returnDate(item.PermitValidity);
    return { ...item, PermitValidity, key };
  });
  return updatedData;
}
function processData_ReportRequest(data: any) {
  const updatedData = data.map((item: any) => {
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const Date = item.Date && returnDate(item.Date);
    const key = item.ID;
    return { ...item, Period, key, Date };
  });
  return updatedData;
}
function processData_ProjectRecords(data: any) {
  const updatedData = data.map((item: any) => {
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Period, key, Date };
  });
  return updatedData;
}
function processData_Noise(data: any) {
  const updatedData = data.map((item: any) => {
    const v1 = parseFloat(item.MonitoringResults1LAeqdBA);
    const v2 = parseFloat(item.MonitoringResults2LAeqdBA);
    const v3 = parseFloat(item.MonitoringResults3LAeqdBA);

    const MaxLAeq = Math.max(v1, v2, v3);
    const AverageLAeq = ((v1 + v2 + v3) / 3).toFixed(2);

    let NoiseLevel: number | null = null;
    if (item.Hour24H !== '') {
      const { TimePeriod, LocationType } = item;

      const mapping: Record<string, Record<string, number>> = {
        Day: {
          Quiet: 75, Sensitive: 75, Mixed: 75,
          'Category A': 50, 'Category B': 55, 'Category C': 60, 'Category D': 65, Roadsides: 70,
        },
        Evening: {
          Quiet: 65, Sensitive: 65, Mixed: 65,
        },
        Night: {
          Quiet: 45, Sensitive: 45, Mixed: 45,
          'Category A': 40, 'Category B': 45, 'Category C': 50, 'Category D': 55, Roadsides: 65,
        },
      };

      NoiseLevel = mapping[TimePeriod]?.[LocationType] ?? 80;
    }

    const Conformity = MaxLAeq <= NoiseLevel! ? 'Conformity' : 'Non Conformity';
    const Period = item.Date ? GetPeriod(item.Date) : '';
    const Date = item.Date ? returnDate(item.Date) : '';
    const pieKey = Conformity;
    const key = item.ID;

    return {
      ...item,
      MaxLAeq,
      AverageLAeq,
      NoiseLevel,
      Conformity,
      Period,
      Date,
      pieKey,
      key,
    };
  });

  return updatedData;
}
function returnDate(value: Date) {
  if (value) {
    const date = new Date(value);
    const timezoneOffset = 4 * 60; // UTC +4 timezone offset in minutes
    const adjustedDate = new Date(date.getTime() + timezoneOffset * 60000);
    const day = adjustedDate.getDate();
    const month = adjustedDate.getMonth() + 1;
    const year = adjustedDate.getFullYear();
    const formattedDate = `${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}/${year}`;
    return formattedDate;
  } else {
    return value;
  }

}
function GetPeriod(value: Date) {
  if (value && value != null) {
    const date = new Date(value);
    const timezoneOffset = 4 * 60; // UTC +4 timezone offset in minutes
    const adjustedDate = new Date(date.getTime() + timezoneOffset * 60000);
    const day = adjustedDate.getDate();
    const month = adjustedDate.getMonth() + 1;
    const year = adjustedDate.getFullYear();
    const formattedDate = `${month < 10 ? '0' + month : month}-${year}`;
    return formattedDate;
  } else {
    return value;
  }
}
function checkDiverted(div: string) {
  //let val;
  switch (div) {
    case "Reuse on-site": return "Diverted";
    case "Reuse off-site": return "Diverted";
    case "Recycling / Recover": return "Diverted";
    case "Landfill": return "Not Diverted";
    case "Dump site": return "Not Diverted";
    case "Other": return "Not Diverted";
    default: return null
  }
}

function checkHazardous(wT: string) {
  //let val;
  switch (wT) {
    case "Paper/ Cardboard": return "Non Hazardous";
    case "Plastic": return "Non Hazardous";
    case "Metal": return "Non Hazardous";
    case "Wood": return "Non Hazardous";
    case "Green": return "Non Hazardous";
    case "Concrete/ Inert debris": return "Non Hazardous";
    case "Asphalt": return "Non Hazardous";
    case "General Domestic/ Food waste": return "Non Hazardous";
    case "General Construction/ Mixed Waste": return "Non Hazardous";
    case "Electronic (without hazardous materials)": return "Non Hazardous";
    case "Other (non hazardous)": return "Non Hazardous";

    case "Electronic (containing hazardous materials)": return "Hazardous";
    case "Used oil": return "Hazardous";
    case "Used oil filters": return "Hazardous";
    case "Contaminated material (including contaminated pads, rags, gloves and soil)": return "Hazardous";
    case "Batteries": return "Hazardous";
    case "Medical": return "Hazardous";
    case "Other (hazardous)": return "Hazardous";
    default: return null
  }
}
function checkReused(div: string) {
  switch (div) {
    case "Reuse on-site": return "Reuse";
    case "Reuse off-site": return "Reuse";
    case "Temporary storage for future reuse": return "Reuse";

    case "Disposal off-site": return "Not Reused";
    case "Landfill": return "Not Reused";
    case "Slurry lagoon": return "Not Reused";
    case "Other": return "Not Reused";
    default: return null
  }
}
function checkStatus(div: string) {
  switch (div) {
    case "Yes": return "Closed";
    case "No": return "Open";
    case "Escalated": return "Escalated";
    default: return null
  }
}
async function createItem(logTitle: string, accessToken: string, clientAPIURL: string, siteId: string, data: Array<any>) {

  const finalUri = clientAPIURL + "api/sites/" + siteId + "/lists/" + logTitle + "/items"
  //const finalUri = baseAPI.replace("{siteId}", siteId).replace("{logTitle}", logTitle);

  try {
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data)
    };
    const result = await fetch(finalUri, requestOptions);

    if (result && !result.ok) {
      //throw new Error(`HTTP error! Status: ${result.status}`);
      return result
    }
    const response = await result.json();
    return response;
  } catch (error) {
    console.error(error);
  }
}
async function upload(logTitle: string, accessToken: string, clientAPIURL: string, siteId: string, data: any) {

  const finalUri = clientAPIURL + "api/sites/" + siteId + "/lists/" + logTitle + "/items"
  //const finalUri = baseAPI.replace("{siteId}", siteId).replace("{logTitle}", logTitle);
  try {
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data)
    };
    const result = await fetch(finalUri, requestOptions);
    const response = await result.json();
    return response;
  } catch (error) {
    console.error(error);
  }
}
async function getItemById(logTitle: string, accessToken: string, clientAPIURL: string, siteId: string, itemId: number) {
  const finalUri = clientAPIURL + "api/sites/" + siteId + "/lists/" + logTitle + "/items"
  //const finalUri = baseAPI.replace("{siteId}", siteId).replace("{logTitle}", logTitle);
  try {
    const url = finalUri + "/" + itemId
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    const response = await fetch(url, requestOptions);
    return await response.json();
  } catch (error) {
    console.error(error);
  }
}

async function getAppConfig(accessToken: string, clientAPIURL: string, key: any) {
  const finalUri = clientAPIURL + "api/AppConfigs"
  try {
    const url = finalUri + "/wasteconversionfactors"
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    const response = await fetch(url, requestOptions);
    return await response.json();
  } catch (error) {
    console.error(error);
  }
}

async function getInputCheckConfig(accessToken: string, clientAPIURL: string, packageId?: string) {
  const finalUri = clientAPIURL + "api/AppConfigs/InputChecks"
  try {
    const url = `${finalUri}${packageId ? `?packageId=${packageId}` : ''}`;
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    const response = await fetch(url, requestOptions);
    return await response.json();
  } catch (error) {
    console.error("Error fetching input check config:", error);
    return null;
  }
}
const formatDateToLocal = (dateString: string) => {
  if (!dateString) return "";
  const utcDate = new Date(`${dateString}Z`);
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const zonedDate = toZonedTime(utcDate, timeZone);
  //console.log(`${timeZone} = ${dateString} = ${zonedDate}`)

  // Format the date as DD/MM/YYYY hh:mm (24-hour format)
  return format(zonedDate, 'dd/MM/yyyy HH:mm');
};
async function updateItem(logTitle: string, accessToken: string, clientAPIURL: string, siteId: string, itemId: number, data: Array<any>) {
  const finalUri = clientAPIURL + "api/sites/" + siteId + "/lists/" + logTitle + "/items"
  //const finalUri = baseAPI.replace("{siteId}", siteId).replace("{logTitle}", logTitle);
  const url = finalUri + "/" + itemId
  try {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data)
    };
    const result = await fetch(url, requestOptions);
    return result;
  } catch (error) {
    console.error(error);
  }
}
async function deleteItem(logTitle: string, accessToken: string, clientAPIURL: string, siteId: string, itemId: number) {

  //clientAPIURL = "https://localhost:44346/";
  const finalUri = `${clientAPIURL}api/sites/${siteId}/lists/${logTitle}/items/${itemId}`;

  try {
    const requestOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };

    const response = await fetch(finalUri, requestOptions);

    if (!response.ok) {
      throw new Error(`Delete request failed: ${response.status} ${response.statusText}`);
    }

    return response;
  } catch (error) {
    console.error("Error deleting item:", error);
    return null; // Ensure failure is handled gracefully
  }
}

export type PackageStatusItem = {
  Month?: string;     // e.g., "Oct" or "October"
  Year?: string | number; // e.g., "2025" or 2025
  Status?: string;    // e.g., "Open", "Re-Open", "Closed"
  [k: string]: any;
};

type BulkUpdateStatusRequest = {
  siteId: string;
  status: string;
  month?: string | null;
  year?: string | null;
  nextFreezeDate?: string | null; // ISO-8601
  triggeredBy: string;
  data: Array<any>;
};

const norm = (v: any) => String(v ?? "").trim().toLowerCase();
const isOpenStatus = (s: any) => /^(open|re-?open)$/i.test(String(s ?? "").trim());

const monthLongs = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
const monthShorts = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function proceedToCreate(
  selectedDate: Date | string | number | null | undefined,
  items: PackageStatusItem[] = []
): boolean {
  if (!selectedDate) return false;

  const dt = new Date(selectedDate);
  if (isNaN(dt.getTime())) return false;

  const monthLong = monthLongs[dt.getMonth()];
  const monthShort = monthShorts[dt.getMonth()];
  const yearStr = String(dt.getFullYear());

  // match Month+Year ignoring case and extra spaces; support "Oct" or "October"
  const matchesMonthYear = (r: PackageStatusItem) =>
    norm(r?.Year) === norm(yearStr) &&
    (norm(r?.Month) === norm(monthLong) || norm(r?.Month) === norm(monthShort));

  const hits = items.filter(matchesMonthYear);

  // no row -> allow; any open-ish -> allow; else block
  if (hits.length === 0) return true;
  return hits.some(r => isOpenStatus(r?.Status));
}

async function packageStatusEmail(accessToken: string, clientAPIURL: string, data: any) {

  const finalUri = clientAPIURL + "api/packagestatusemail"
  try {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data)
    };
    const result = await fetch(finalUri, requestOptions);
    return result;
  } catch (error) {
    console.error(error);
  }

}


async function bulkUpdatePackageStatus(accessToken: string, clientAPIURL: string, data: BulkUpdateStatusRequest) {

  const finalUri = clientAPIURL + "api/bulkUpdatePackageStatus"
  try {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data)
    };
    const result = await fetch(finalUri, requestOptions);
    if (!result.ok) {
      return result;
    }
    return await result.json();
  } catch (error) {
    console.error(error);
  }

}


export { bulkUpdatePackageStatus, packageStatusEmail, proceedToCreate, getComplianceConfig, getKpiConfig, getAppSettingsConfig, findProjectParent, getPackageStatus, findImmediateParent, formatDateToLocal, getAllItems, createItem, deleteItem, updateItem, getItemById, upload, triggerWorkflow, triggerReportRequest, getAssetData, getAppConfig, getInputCheckConfig };
